// src/admin/sections/CravingsScreen.jsx
//
// The Cravings nav item (spec 0e): one screen, two views. "All cravings" is the
// log of what readers typed (ticket 37); "Overheard" is the examples under the
// craving box (ticket 38). A reader's words reach Overheard by being picked from
// the log, so picking one and seeing it land belong on one screen: after an Add
// in the log, "See it in Overheard" switches to the second view.
//
// The view lives in the URL (?view=overheard), like the Health tabs, so a view
// can be bookmarked and survives a reload.

import { useTabParam } from '../../hooks/useTabParam';
import CravingsSection from './CravingsSection';
import OverheardSection from './OverheardSection';

const VIEWS = [
  { id: 'all',       label: 'All cravings' },
  { id: 'overheard', label: 'Overheard' },
];

export default function CravingsScreen({ isMobile }) {
  const [viewParam, setView] = useTabParam('view', 'all');
  const view = VIEWS.some(v => v.id === viewParam) ? viewParam : 'all';
  const pad = isMobile ? 16 : '30px 36px';

  return (
    <div style={{ padding: pad, fontFamily: 'var(--font-body)' }}>
      <div style={{ marginBottom: 16 }}>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 26, fontWeight: 700, color: 'var(--neutral-800)', letterSpacing: -0.6, lineHeight: 1.1, margin: 0 }}>Cravings</h1>
        <p style={{ fontSize: 'var(--font-size-base)', color: 'var(--neutral-500)', marginTop: 4 }}>
          {view === 'overheard'
            ? 'The examples under the craving box: write one, switch it showing or off, edit it, delete it.'
            : 'What readers typed into the craving box, in their own words.'}
        </p>
      </div>

      <div style={{ display: 'flex', borderBottom: '2px solid var(--brand-sand)', marginBottom: 18, ...(isMobile ? { overflowX: 'auto' } : {}) }}>
        {VIEWS.map(v => (
          <button key={v.id} type="button" onClick={() => setView(v.id)} style={{
            fontSize: 'var(--font-size-sm)', fontWeight: 600, padding: isMobile ? '0 14px' : '8px 16px', minHeight: isMobile ? 44 : undefined, whiteSpace: 'nowrap',
            color: view === v.id ? 'var(--neutral-800)' : 'var(--neutral-400)', border: 'none', background: 'transparent',
            borderBottom: view === v.id ? '2px solid var(--neutral-800)' : '2px solid transparent',
            marginBottom: -2, cursor: 'pointer', fontFamily: 'var(--font-body)',
          }}>
            {v.label}
          </button>
        ))}
      </div>

      {view === 'overheard'
        ? <OverheardSection isMobile={isMobile} />
        : <CravingsSection isMobile={isMobile} onSeeOverheard={() => setView('overheard')} />}
    </div>
  );
}
